/* STEP 7b (Card V2, 29-Oct-2026) — lane 7b fixes: the Founder tenant form's caps (C1 / C4); 7b-3: the step-up dialog (D1),
   the Two-Factor card of Settings (D2), the analysis pages' financial-year period line (F6), the EQ-date line "not required"
   (F4). EN + AR.
   Loaded from lib/i18n/ by the generated index (STEP 2 · B2). */
export const I18N_S7B = {
  en: {
    s7b: {
      caps: {
        unlimited: "Unlimited",
        maxUsers: "Max users (blank = unlimited)",
        maxEngagements: "Max engagements (blank = unlimited)",
        fromPlan: "Filled in from the plan. Clear a field to make that cap unlimited.",
      },
      stepUp: {
        title: "Confirm your identity",
        desc: "This is a sensitive action — please re-verify with a fresh code. The code expires in 5 minutes.",
        descEmail: "This is a sensitive action — please re-verify with a fresh code sent to {email}. The code expires in 5 minutes.",
        deliveryFailed: "Couldn't email your code just now. Tap \"Send a new code\" below to retry.",
        resend: "Send a new code",
        cancel: "Cancel",
        verifying: "Verifying…",
        verify: "Verify",
        verified: "Step-up verified",
        sendFailed: "Could not send step-up code",
        verifyFailed: "Verification failed",
      },
      twofa: {
        title: "Two-Factor Authentication",
        status: "Status",
        enabledEmail: "Enabled (email)",
        grace: "Grace window active until rollout ends",
        lastVerified: "Last verified",
        stepupEvery: "Step-up re-verification is asked every {n} min for sensitive actions.",
        backupCodes: "Backup codes",
        remaining: "{n} remaining",
        regenerate: "Regenerate backup codes",
        generate: "Generate backup codes",
        issued: "New backup codes issued",
        regenFailed: "Failed to regenerate codes",
        copied: "Copied",
        copyFailed: "Copy failed",
        confirmTitle: "Regenerate backup codes?",
        confirmBody: "Any existing backup codes will stop working immediately. You'll get a fresh set of 10 single-use codes.",
        cancel: "Cancel",
        working: "Working…",
        regenerateShort: "Regenerate",
        newTitle: "Your new backup codes",
        saveNow: "Save these now — you won't see them again after closing this dialog.",
        copyAll: "Copy all",
        download: "Download .txt",
        saved: "I've saved them",
      },
      period: {
        fy: "Financial year analysed: {start} – {end}",
        pyNote: "Prior-year months are shown only as a comparison, below.",
        pyTitle: "Prior year (comparison) — {start} – {end}",
        pyMonthly: "Monthly net movement by category (prior year, not in the pairs)",
        oldRun: "This result was computed before the financial-year rule — run the analysis again.",
      },
      eq: {
        notRequired: "EQ review not required for this engagement — the date check does not apply.",
      },
      lead: {
        pyLeadTotal: "PY lead total",
        pyFsTotal: "PY FS total",
        pyDiff: "PY difference to financial statements",
        pyNotShown: "Prior year: not shown on the financial statements.",
      },
    },
  },
  ar: {
    s7b: {
      caps: {
        unlimited: "غير محدود",
        maxUsers: "الحد الأقصى للمستخدمين (فارغ = غير محدود)",
        maxEngagements: "الحد الأقصى للمهام (فارغ = غير محدود)",
        fromPlan: "مُعبّأ من الخطة. امسح الحقل ليصبح ذلك الحد غير محدود.",
      },
      stepUp: {
        title: "تأكيد هويتك",
        desc: "هذا إجراء حساس — يُرجى إعادة التحقق برمز جديد. تنتهي صلاحية الرمز خلال 5 دقائق.",
        descEmail: "هذا إجراء حساس — يُرجى إعادة التحقق برمز جديد أُرسل إلى {email}. تنتهي صلاحية الرمز خلال 5 دقائق.",
        deliveryFailed: "تعذّر إرسال الرمز إلى بريدك الإلكتروني الآن. اضغط \"إرسال رمز جديد\" أدناه لإعادة المحاولة.",
        resend: "إرسال رمز جديد",
        cancel: "إلغاء",
        verifying: "جارٍ التحقق…",
        verify: "تحقّق",
        verified: "تم التحقق الإضافي",
        sendFailed: "تعذّر إرسال رمز التحقق",
        verifyFailed: "فشل التحقق",
      },
      twofa: {
        title: "المصادقة الثنائية",
        status: "الحالة",
        enabledEmail: "مفعّلة (البريد الإلكتروني)",
        grace: "فترة السماح سارية حتى انتهاء مرحلة التفعيل",
        lastVerified: "آخر تحقق",
        stepupEvery: "يُطلب إعادة التحقق للإجراءات الحساسة كل {n} دقيقة.",
        backupCodes: "الرموز الاحتياطية",
        remaining: "المتبقي: {n}",
        regenerate: "إعادة إنشاء الرموز الاحتياطية",
        generate: "إنشاء الرموز الاحتياطية",
        issued: "صدرت رموز احتياطية جديدة",
        regenFailed: "تعذّرت إعادة إنشاء الرموز",
        copied: "تم النسخ",
        copyFailed: "تعذّر النسخ",
        confirmTitle: "إعادة إنشاء الرموز الاحتياطية؟",
        confirmBody: "ستتوقف أي رموز احتياطية حالية عن العمل فورًا، وستحصل على مجموعة جديدة من 10 رموز يُستخدم كل منها مرة واحدة.",
        cancel: "إلغاء",
        working: "جارٍ التنفيذ…",
        regenerateShort: "إعادة الإنشاء",
        newTitle: "رموزك الاحتياطية الجديدة",
        saveNow: "احفظ هذه الرموز الآن — لن تظهر لك مرة أخرى بعد إغلاق هذه النافذة.",
        copyAll: "نسخ الكل",
        download: "تنزيل ملف نصي",
        saved: "حفظتها",
      },
      period: {
        fy: "السنة المالية التي جرى تحليلها: {start} – {end}",
        pyNote: "تُعرض أشهر السنة السابقة للمقارنة فقط، أدناه.",
        pyTitle: "السنة السابقة (للمقارنة) — {start} – {end}",
        pyMonthly: "صافي الحركة الشهرية حسب الفئة (السنة السابقة، خارج الأزواج)",
        oldRun: "حُسبت هذه النتيجة قبل قاعدة السنة المالية — أعد تشغيل التحليل.",
      },
      eq: {
        notRequired: "مراجعة جودة الارتباط غير مطلوبة لهذا الارتباط — فحص التاريخ لا ينطبق.",
      },
      lead: {
        pyLeadTotal: "إجمالي الورقة الرئيسية للسنة السابقة",
        pyFsTotal: "إجمالي القوائم المالية للسنة السابقة",
        pyDiff: "الفرق مع القوائم المالية للسنة السابقة",
        pyNotShown: "السنة السابقة: غير معروضة في القوائم المالية.",
      },
    },
  },
};

export default I18N_S7B;
